// extracted by mini-css-extract-plugin
export var dropdownButton = "_29-0";
export var fullWidthDropdownButton = "_29-1";
export var icon = "_29-3";
export var iconPlaceholder = "_29-2";
export var menuItemRow = "_29-8";
export var separator = "_29-d";
export var shortcutContainer = "_29-7";
export var shortcutIconLg = "_29-6";
export var shortcutIconMd = "_29-5";
export var shortcutIconSm = "_29-4";
export var submenuChevron = "_29-c";
export var submenuDropdown = "_29-9";
export var submenuTriggerRow = "_29-a";
export var submenuTriggerRowOpen = "_29-b";